import { ChangeEvent, KeyboardEvent } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { ReactElement } from "react";
import { className } from "../../../../shared/helpers";
import { TableState } from "../../table-data";
import styles from "./SearchInput.module.scss";

interface SearchInputProps
{
    id?: string;
    name?: string;
    autoComplete?: string;
    placeholder?: string;
    handleSearch: (text: string) => void;
    isLoading: boolean;
    tableState: TableState;
}

const SearchInput = (props: SearchInputProps): ReactElement =>
{
    const inputRef = useRef<HTMLInputElement>(null as any);
    const lastSearchRef = useRef<string>("");
    const [searchText, setSearchText] = useState<string>("");
    const [searching, setSearching] = useState(true);

    function handleChange(e: ChangeEvent): void
    {
        const target = e.target as HTMLInputElement;
        const trimmedValue = target.value.trim();
        if (searchText !== target.value) {
            setSearchText(trimmedValue);
        };
    }

    function handleKeyUp(e: KeyboardEvent): void
    {
        const target = e.target as HTMLInputElement;

        if (target.value.trim() === "")
        {
            target.value = "";
        }
        if (e.key === "Enter") search();
    }

    function search(): void
    {
        if (searchText === "" || searchText === lastSearchRef.current) return;
        setSearching(true);
        props.tableState.data.clearRows();
        props.handleSearch(searchText);
        lastSearchRef.current = searchText;
    }

    function reset(): void
    {
        if (lastSearchRef.current !== "") {
            props.handleSearch("");
            lastSearchRef.current = "";
        };

        setSearchText("");
        inputRef.current.value = "";
    }

    useEffect(() => {
        setSearching(props.isLoading);
    }, [props.isLoading])

    return (
        <div className={styles.searchInput}>
            <div className={styles.inputWrapper}>
                <input
                    type="text"
                    ref={inputRef}
                    id={props.id}
                    name={props.name}
                    placeholder={props.placeholder ?? "Search..."}
                    autoComplete={props.autoComplete ?? "off"}
                    onChange={handleChange}
                    onKeyUp={handleKeyUp}
                    disabled={searching}
                />

                <i {...className("material-icons", styles.searchIcon)}>search</i>

                {(searchText !== "" || searchText !== lastSearchRef.current) && (
                    <button
                        className={styles.resetBtn}
                        onClick={reset}
                        disabled={searching}
                    >
                        <i className="material-icons">close</i>
                    </button>
                )}
            </div>

            <button
                {...className("btn btn-info", styles.submitBtn)}
                style={{ pointerEvents: searchText !== "" ? "all" : "none" }}
                onClick={search}
                disabled={searching || searchText === "" || searchText === lastSearchRef.current}
            >
                Apply
            </button>
        </div>
    )
}

export default SearchInput;